
import css from 'styled-jsx/css';

export default css`.companies-marquee {
  display: inline-flex;
  width: 100%;

  &__logos {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  :global(picture img) {
    height: 4rem;
    object-fit: contain;
    width: auto;
  }
}
`